// @flow
import { getParticipantDisplayName } from '../base/participants';
import {
    NOTIFICATION_TYPE,
    showNotification
} from '../notifications';

export function notifyKickedOut(participant) { // eslint-disable-line no-unused-vars
    return (dispatch, getState) => {
        if (!participant || (participant.isReplaced && participant.isReplaced())) {
            return;
        }

        const args = {
            participantDisplayName:
                getParticipantDisplayName(getState, participant.getId())
        };

        dispatch(showNotification({
            appearance: NOTIFICATION_TYPE.ERROR,
            hideErrorSupportLink: true,
            descriptionKey: 'dialog.kickMessage',
            descriptionArguments: args,
            titleKey: 'dialog.kickTitle',
            titleArguments: args
        }));
    };
}
